<template>
  <div>
    <table class="table table-hover table-hover-pink table-candidate table-homepage">
      <thead>
        <tr>
          <th>{{ $t('table.headers.name') }}</th>
          <th>{{ $t('table.headers.occupations') }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <awaiting-candidate-table-row v-for="(user, index) in users"
                                      :key="`user_${userState}_${index}`"
                                      :user="user"
                                      :state="userState"
                                      :entityId="entityId" />
      </tbody>
    </table>
  </div>
</template>

<script>
  import AwaitingCandidateTableRow from './AwaitingCandidateTableRow'

  export default {
    name: 'AwaitingCandidateTable',
    props: ['users', 'userState', 'entityId'],
    components: {
      AwaitingCandidateTableRow
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/manager/AwaitingCandidateTable.vue